import React, {useEffect, useState} from 'react';

import Map from '../../components/Map/Map';
import Infographic from '../../components/Infographic/Infographic';
import Panzoom from '@panzoom/panzoom'

import { useModal, useModalUpdate, useModalClose } from "../../components/context/ModalContext";
import { usePDF, usePDFUpdate } from "../../components/context/PDFContext";

import { gaMapSelect, gaPDFDownload } from '../../utils/gatags';


import pdf0 from '../../assets/pdf/Fastfacts_United-States.pdf';
import pdf1 from '../../assets/pdf/Fastfacts_Sweden.pdf';
import pdf2 from '../../assets/pdf/Fastfacts_Denmark.pdf';
import pdf3 from '../../assets/pdf/Fastfacts_United-Kingdom.pdf';
import pdf4 from '../../assets/pdf/Fastfacts_Germany.pdf';
import pdf5 from '../../assets/pdf/Fastfacts_Belgium.pdf';
import pdf6 from '../../assets/pdf/Fastfacts_France.pdf';
import pdf7 from '../../assets/pdf/Fastfacts_Italy.pdf';
import pdf8 from '../../assets/pdf/Fastfacts_Eastern-Europe.pdf';
import pdf9 from '../../assets/pdf/Fastfacts_New-Zealand.pdf';




// import { useDataUpdate } from "../../components/context/DataContext";

// import { gaButtonClick } from '../../utils/gatags';

import './Content.css';
import References from '../../components/References/References';



const Content = () => {

    const countryArray = ["United-States","Sweden","Denmark","United-Kingdom","Germany","Belgium","France","Italy","Eastern-Europe","New-Zealand"];

    const pdfarray = [
        pdf0,
        pdf1,
        pdf2,
        pdf3,
        pdf4,
        pdf5,
        pdf6,
        pdf7,
        pdf8,
        pdf9,
      ]



    // 


    // const [data, setData] = useState(null);

    const pdfIdx = usePDFUpdate(true);
    const setPDFIdx = usePDFUpdate(true);

    const pdfModalSet = useModalUpdate(true);
    const setModalClose = useModalClose();
    const setModalContent = (_sec) => {
        gaMapSelect(countryArray[_sec]);
        pdfModalSet(true);
    }


    const zoomClick = (_idx) => {
        setPDFIdx(_idx);
        setModalContent(_idx);
    }

    const hoverInElem = (_idx) => {
        // console.log(`hover in: ${_idx}` );
        let country = 'country' + _idx;
        let countryID = document.getElementById(country);
        let lbl = 'lbl' + _idx;
        let lblID = document.getElementById(lbl);
        countryID.classList.add("showCountry");
        lblID.classList.add("showCountry");
    }
    const hoverOutElem = (_idx) => {
        // console.log(`hover out: ${_idx}` );
        removeClass();
    }

    const downloadPDF = (e) => {
        window.open(pdfarray[e],"_blank", "download");
        gaPDFDownload('pdfarray[e]');
    }

    const removeClass = () => {
        const elementsCountryArray = document.getElementsByClassName('country');
        [...elementsCountryArray].forEach((el, index, array) => {
            el.classList.remove("showCountry");
        });
        const elementsLblArray = document.getElementsByClassName('lbl');
        [...elementsLblArray].forEach((el, index, array) => {
            el.classList.remove("showCountry");
        });
    }

    const elem = document.getElementById('map-wrap');


    useEffect(() => {





       



    //     fetch('./content.json'
    // ,{
    //   headers : { 
    //     'Content-Type': 'application/json',
    //     'Accept': 'application/json'
    //    }
    // }
    // )
    // .then(function(response){
    //     return response.json();
    // })
    // .then(function(dataJson) {
    //     setData(dataJson);
    //     setDataState(dataJson);
    // });

    const elem = document.getElementById('map-wrap');

    const panzoom = Panzoom(elem, {
        maxScale: 5,
        minScale: 1
    })
    panzoom.pan(10, 10)
    // panzoom.zoom(1, { animate: true })

    // Panning and pinch zooming are bound automatically (unless disablePan is true).
    // There are several available methods for zooming
    // that can be bound on button clicks or mousewheel.
    const scaleUpBtn = document.getElementById("scale-up");
    const scaleDownBtn = document.getElementById("scale-down");
    const resetBtn = document.getElementById("reset");
    scaleUpBtn.addEventListener('click', (e) => {
        console.log("zoomin");
        panzoom.zoomIn();
    });
    scaleDownBtn.addEventListener('click', (e) => {
        panzoom.zoomOut();
    });
    resetBtn.addEventListener('click', (e) => {
        panzoom.reset();
    });
    // elem.parentElement.addEventListener('wheel', panzoom.zoomWithWheel)
    window.addEventListener('resize', () => {
        if (window.innerWidth <= 768) {
            setModalClose();
            removeClass();
        }
        
    });

    }, []) 



    return (
        <div className="App">
            <div id="component-574088">

                <div id="desktop-container" className="content-desktop">

                    <div id="header-cmp">
                        <h1 className="center">Explore real-life examples of <span className="adpt-bk"><br></br></span>biosimilars‘ benefits across the world</h1>
                        <p className="center">Reveal case studies by clicking on the relevant country on the map.</p>
                    </div>

                    <div id="map-container">
                        <div id="map-wrap">
                            <Map func={e => zoomClick(e)} hoverin={hoverInElem} hoverout={hoverOutElem}/>
                        </div>

                        <div id="map-ctrls">
                            <div id="scale-up" className="map-ctrl-btn"></div>
                            <div id="scale-down" className="map-ctrl-btn"></div>
                            <div id="reset" className="map-ctrl-btn"></div>
                        </div>


                    </div>
                    

                    <div className="infographic">
                        {/* <Infographic /> */}
                        <img width="100%" src={require("../../assets/images/infographic@2x.png")} alt="The values biosimilars bring to patients infographic" />
                    </div>
                    <References />
                </div>

                <div id="mobile-container">

                    <div id="header-cmp">
                        <h1 className="center">Explore real-life examples of <span className="adpt-bk"><br></br></span>biosimilars‘ benefits across the world</h1>
                    </div>

                    <div id="map-container-mobile">
                        <div id="link-wrap">
                            <div onClick={() => {downloadPDF(5)}} className="mob-link" data-linkid="5"><span className="icn"></span><p>Belgium</p></div>
                            <div onClick={() => {downloadPDF(2)}} className="mob-link" data-linkid="2"><span className="icn"></span><p>Denmark</p></div>
                            <div onClick={() => {downloadPDF(8)}} className="mob-link" data-linkid="8"><span className="icn"></span><p>Eastern Europe</p></div>
                            <div onClick={() => {downloadPDF(6)}} className="mob-link" data-linkid="6"><span className="icn"></span><p>France</p></div>
                            <div onClick={() => {downloadPDF(4)}} className="mob-link" data-linkid="4"><span className="icn"></span><p>Germany</p></div>
                            <div onClick={() => {downloadPDF(7)}} className="mob-link" data-linkid="7"><span className="icn"></span><p>Italy</p></div>
                            <div onClick={() => {downloadPDF(9)}} className="mob-link" data-linkid="9"><span className="icn"></span><p>New Zealand</p></div>
                            <div onClick={() => {downloadPDF(1)}} className="mob-link" data-linkid="1"><span className="icn"></span><p>Sweden</p></div>
                            <div onClick={() => {downloadPDF(3)}} className="mob-link" data-linkid="3"><span className="icn"></span><p>United Kingdom</p></div>
                            <div onClick={() => {downloadPDF(0)}} className="mob-link" data-linkid="0"><span className="icn"></span><p>United States</p></div>
                        </div>
                        <References />
                    </div>

                </div>

            </div>
        </div>
        );
    };
    
    export default Content;